import { render } from "./ListDataIjinApprove.vue?vue&type=template&id=0dfd6997"
import script from "./ListDataIjinApprove.vue?vue&type=script&lang=js"
export * from "./ListDataIjinApprove.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__